import { useEffect } from 'react'

export const DisableBodyScroll = () => {
  useEffect(() => {
    // Store the original overflow value
    const originalOverflow = document.body.style.overflow

    // Set overflow to hidden
    document.body.style.overflow = 'hidden'

    // Cleanup: restore original overflow when unmounting
    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [])

  return null
}
